import { render, staticRenderFns } from "./news_business.vue?vue&type=template&id=55504d5e&"
import script from "./news_business.vue?vue&type=script&lang=js&"
export * from "./news_business.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports